  
const PopUpFormButton = ({url, className,children, name, element, field="name", isNew=null, finalizeTag=(id, tag, isNew)=>{}}) =>{
    name = name || element.form_title
    const setForm = () => {
        url = url.replace('/rest/', '/f/')
        const __popup = parseInt(new URLSearchParams(window.location.search).get('__popup') || 0) + 1
        url.includes('?') ? url += '&__popup=' + __popup : url += '?__popup=' + __popup
        window.finalizeTag = (id, tag) => finalizeTag( id, tag, isNew)
        window.open(url, field+"___popup_"+__popup, 'height=768,width=650,left=10,top=10,fullscreen=1,titlebar=no,toolbar=no,menubar=no,location=no,directories=no,status=no');
    }
    return <a className={`d-flex align-items-center action-button ${className}`} onClick={setForm}>
            {children}
            {name}
    </a>

}

export default PopUpFormButton;